import { useState } from 'react';

import { ExternalLink, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import UserCard from '@/features/settings/components/UserCard';
import useOutlookConnection, {
  getOutlookConnectionError,
} from '@/features/settings/queries/hooks/useOutlookConnection';

import { Button } from '../shadcn/button';

import PlatformLink from './PlatformLink';

const CONNECTION_POLL_INTERVAL_MS = 2000;

export default function ConnectOutlook() {
  const { t } = useTranslation();
  const [hasOpenedConnectPage, setHasOpenedConnectPage] = useState(false);

  const { data: outlookConnection, isPending } = useOutlookConnection({
    refetchInterval: hasOpenedConnectPage ? CONNECTION_POLL_INTERVAL_MS : false,
    refetchOnWindowFocus: true,
  });

  const connectionError = getOutlookConnectionError(outlookConnection);

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center gap-4 p-4">
      <div className="flex flex-col gap-4 rounded border p-4">
        <img src="/assets/outlook.svg" alt="Outlook logo" className="w-8" />

        <div className="flex flex-col gap-2">
          <h2>{t('OUTLOOK_CONNECT_MANDATORY_TITLE')}</h2>

          <ul className="flex flex-col gap-2">
            <li className="text-muted-foreground text-sm">
              {t('OUTLOOK_CONNECT_MANDATORY_LINE_1')}
            </li>

            <li className="text-muted-foreground text-sm">
              {t('OUTLOOK_CONNECT_MANDATORY_LINE_2')}
            </li>
          </ul>
        </div>

        {connectionError && (
          <div className="rounded bg-red-100 p-2 text-sm text-red-600 dark:bg-red-950 dark:text-red-300">
            {connectionError}
          </div>
        )}

        <div className="flex flex-col gap-2">
          {isPending && (
            <Button disabled className="bg-[#0075DA] hover:bg-[#115EA3]">
              <Loader2 className="animate-spin" />

              {t('CONNECT_OUTLOOK_BUTTON')}
            </Button>
          )}

          {!isPending && (
            <Button asChild className="bg-[#0075DA] hover:bg-[#115EA3]">
              <PlatformLink
                to="/settings/connections/external"
                target="_blank"
                onClick={() => setHasOpenedConnectPage(true)}
              >
                {hasOpenedConnectPage && <Loader2 className="animate-spin" />}

                {t('CONNECT_OUTLOOK_BUTTON')}

                <ExternalLink />
              </PlatformLink>
            </Button>
          )}
        </div>
      </div>

      <UserCard />
    </div>
  );
}
